/**
 * The FaqCategory container
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";

/**
 * The `show` container for an FaqCategory.
 * Both the component and the connected component are exported for testing purpose
 */
export class FaqCategoryView extends Component {
  /**
   * renders the faqcategory data
   */
  render() {
    const { faqcategory, handleShowAllFaq } = this.props;

    return (
      <Container>
        <header>
          {handleShowAllFaq && (
            <Button
              color="link"
              className="back-link"
              onClick={handleShowAllFaq}
            >
              &laquo; {this.context.t("go back to all categories")}
            </Button>
          )}
          {faqcategory.title && (
            <h1 className="h2">
              {this.context.t("Frequently asked questions on")}{" "}
              {faqcategory.title}
            </h1>
          )}
        </header>
        <Row>
          <Col md={8}>
            <ul className="faqcatgegory-faqlist">
              {faqcategory.faqs &&
                faqcategory.faqs.map((faq) => (
                  <li key={faqcategory.faqs.id}>
                    <Link to={`/${faq.language}/faq/${faq.slug}/`}>
                      <span className="faqcatgegory-faqlist-faq h5">
                        {faq.question}
                      </span>
                      <span className="faqcatgegory-faqlist-more">
                        {this.context.t("Read full answer")} &raquo;
                      </span>
                    </Link>
                  </li>
                ))}
            </ul>
            {faqcategory?.faqs?.length === 0 && (
              <p className="text-secondary text-center">
                {this.context.t(
                  "This category is currently under revision. Content will be updated shortly. Kindly check back in a few hours. Thank you for your patience."
                )}
              </p>
            )}
          </Col>
          <Col md={4}>{/* maybe other categories here */}</Col>
        </Row>
      </Container>
    );
  }
}

/**  define proptype for the 'translation' function  */
FaqCategoryView.contextTypes = {
  t: PropTypes.func,
};

/** export the redux connected component and add a frontload call */
export default FaqCategoryView;
